/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchPostsSkeleton.defs.js'
export { main as default } from './searchPostsSkeleton.defs.js'
